import { Button, Checkbox, Color, Kind, ModalWindow } from '@usitsdasdesign/dds-react';
import { yupValidator } from 'lib/yup-validator';
import RenderFields from 'molecules/RenderFields';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { getWorkingHoursPerWeek, getMaxWorkingHoursPerWeek, getAllocationShiftTimingsByAllocationId } from 'services/allocation.service';
import { useState, useEffect, useCallback, useMemo } from 'react';
import AlertModal from 'molecules/AlertModal';
import Text from 'atoms/Text';
import Dialog from './Dialog';
import SearchableSelect from 'molecules/SearchableSelect';
import Input from 'atoms/Input';
import { checkTwoDecimalPlace, getAgeing } from 'helper/util';
import { getProratedWeeklyHoursLimit } from 'lib/util';
import { continuityReasonsOption, TNT_FUNCTION_CODE } from 'helper/constants';
import Drawer from './Drawer';
import AddShiftDrawer from '@/components/AddShiftDrawer';
import ButtonGroup from './ButtonGroup';
import { getDemandShiftTimingsByDemandId } from 'services/demand.service';
import { generateShiftTimings, getDemandShiftTimingFormData, getProposalShiftTimingsPayload, validateMandatoryShiftTimings } from 'helper/shift-timings/helper-function';
import { usePathname } from 'next/navigation';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { getProposalShiftTimingsByProposalId } from 'services/proposal.service';
import useGlobalToastStore from 'store/globalToastStore';
import AddShiftDrawerOCS from '@/components/AddShiftDrawerOCS';
import { loadWbsL4CodeOptions } from 'services/options.service';
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
function Schedule({
    show = false,
    onClose,
    onSave,
    title = 'Change schedule',
    saveLabel = 'Save',
    startDateLabel = 'Schedule Start date',
    demandData = null,
    defaultValues = {},
    isArticle = false,
    isAllocation = true,
    isEdit = false,
    isAudit = false,
    isProposal = false,
    wbsDropdownData = {}
}) {
    if (!show) return null;
    const isSpecialProject = useMemo(() => {
        return demandData?.project?.isSpecialProject || false;
    }, [demandData?.project]);
    const isTNTFunction = defaultValues?.functionCode === TNT_FUNCTION_CODE;
    const isArticleGrade = isArticle;
    const [alertAllocationHourShow, setAlertAllocationHourShow] = useState({ show: false, message: '' });
    const [hrsPerWeekUpperLimit, setHrsPerWeekUpperLimit] = useState(getWorkingHoursPerWeek({ isArticleGrade, isSpecialProject, isTNTFunction }));
    const [maxHoursPerWeek, setMaxHoursPerWeek] = useState(getMaxWorkingHoursPerWeek());
    const [showShiftModal, setShowShiftModal] = useState(false);
    const { setToastData } = useGlobalToastStore();
    const [showOcsShiftModal, setShowOcsShiftModal] = useState(false);
    const proposedDate = (defaultValues?.createdAt ? moment(defaultValues.createdAt).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'));
    const proposalAgeing = getAgeing((defaultValues?.createdAt ? moment(defaultValues.createdAt).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY')), moment().format('MM/DD/YYYY'), 'day');


    const testAllocationHour = (val, watch) => {
        if (!val && val !== 0) return true;
        const weekendInclude = watch('include');
        let includeSat; let includeSun;
        if (weekendInclude) {
            includeSat = weekendInclude[0].value;
            includeSun = weekendInclude[1].value;
        }
        const hoursPerWeekValue = getWorkingHoursPerWeek(
            { includeSunday: includeSun, includeSaturday: includeSat, isArticleGrade, isSpecialProject, isTNTFunction }
        );

        const maxHoursPerWeek = getMaxWorkingHoursPerWeek({ includeSaturday: includeSat, includeSunday: includeSun });
        setMaxHoursPerWeek(maxHoursPerWeek);
        setHrsPerWeekUpperLimit(hoursPerWeekValue);
        if (isAllocation) {
            return isArticleGrade ? val <= hoursPerWeekValue : val <= maxHoursPerWeek;
        }

        return val <= hoursPerWeekValue;
    };

    const demandStartDate = moment(demandData?.demandStartDate || demandData?.startDate || defaultValues.demand?.startDate || defaultValues?.startDate).format('MM/DD/YYYY');
    const matchingListStartDate = moment(defaultValues.startDate).format('MM/DD/YYYY');

    const { linkedWbsL4Count } = wbsDropdownData?.projectDetails || { linkedWbsL4Count: 0}
    const showWbsL4CodeDropdown = linkedWbsL4Count > 1 && !wbsDropdownData?.demandData?.sapProject?.engagementCode
            && !(wbsDropdownData?.demandData?.swiftWbsCode?.billable_l4_wbs_code || wbsDropdownData?.projectDetails?.wbsL4Code);

    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        trigger,
        reset,
        formState: { errors, isValid },
        clearErrors
    } = useForm({
        mode: 'onChange',
        resolver: yupValidator(
            yup.object().shape(((demandData || defaultValues?.demand) && isAllocation) ? {
                startDate: yup.string().required('Start date is required')
                    .test(
                        'value',
                        `Schedule start date cannot be before the demand start date (${demandStartDate})`,
                        (val) => {
                            let startDate;
                            if (demandData) {
                                startDate = demandData?.demandStartDate || demandData?.startDate;
                                return moment(val).isSameOrAfter(moment(startDate).format('MM/DD/YYYY'));
                            } if (defaultValues.demand) {
                                startDate = defaultValues.demand?.startDate;
                                return moment(val).isSameOrAfter(moment(startDate).format('MM/DD/YYYY'));
                            }
                        }
                    ),
                endDate: yup.string().required('End date is required')
                    .test(
                        'value',
                        `Schedule end date cannot be before the demand start date (${demandStartDate})`,
                        (val) => {
                            let startDate;
                            if (demandData) {
                                startDate = demandData?.demandStartDate || demandData?.startDate;
                                return !moment(val).isBefore(moment(startDate, 'MM/DD/YYYY'));
                            } if (defaultValues.demand) {
                                startDate = defaultValues.demand?.startDate;
                                return !moment(val).isBefore(moment(startDate));
                            }
                        }
                    )
                    .test('value', 'End date should be equal or after the start date', (val) => {
                        const endDate = moment(val).startOf('day');
                        const startDate = moment(watch('startDate')).startOf('day');
                        return moment(endDate).isSameOrAfter(startDate);
                    }),
                hoursPerWeek: yup.string().required('Hours/Week is required')
                    .test('value', 'Hours/Week should be greater than 0', (val) => {
                        const newVal = Number(val);
                        return newVal > 0;
                    })
                    .test(
                        'is-decimal',
                        'Hours/Week should have at most 2 decimal places',
                        (val) => checkTwoDecimalPlace(val)
                    )
                    .test(
                        'value',
                        `Hours/Week should not be greater than
                          ${isArticleGrade || isTNTFunction ? hrsPerWeekUpperLimit : maxHoursPerWeek}`,
                        (val) => testAllocationHour(val, watch)
                    ),
                include: yup.array(),
                adjustedUtilizations: yup.boolean(),
                isContinuityResource: yup.boolean(),
                continuityReason: yup.object().test('value', 'Continuity reason is required', (val) => {
                    if (!watch('isContinuityResource')) return true;
                    return !!watch('continuityReason')?.value;
                }).nullable(),
                continuityReasonComment: yup.string().nullable(),
                wbsL4Code: showWbsL4CodeDropdown ? yup.mixed().required('WBS/Eng. Code is required') : yup.mixed().notRequired(),
            } : {
                startDate: yup.string().required('Start date is required')
                    .test(
                        'value',
                        `Schedule start date can be on or after the demand start date (${demandStartDate})`,
                        (val) => {
                            let startDate;
                            if (demandData) {
                                startDate = demandData?.demandStartDate || demandData?.startDate;
                                return moment(val).isSameOrAfter(moment(startDate, 'MM/DD/YYYY').startOf('day'));
                            }

                            if (defaultValues.demand) {
                                startDate = defaultValues.demand?.startDate;
                                return moment(val).isSameOrAfter(moment(startDate, 'MM/DD/YYYY').startOf('day'));
                            }

                            if (defaultValues?.startDate) {
                                startDate = defaultValues?.startDate;
                                return moment(val).isSameOrAfter(moment(startDate, 'MM/DD/YYYY').startOf('day'));
                            }

                            return true;
                        }
                    ),
                endDate: yup.string().required('End date is required').test('value', `End date should be equal or after the start date`, (val) => {
                    const endDate = moment(val).startOf('day');
                    const startDate = moment(watch('startDate')).startOf('day');
                    return moment(endDate).isSameOrAfter(startDate);
                }),
                hoursPerWeek: yup.number().required('Hours/Week is required')
                    .test(
                        'value',
                        'Hours/Week should be greater than 0',
                        (val) => val > 0
                    )
                    .test(
                        'valid-hoursPerWeek',
                        function (val) {
                            if (!testAllocationHour(val, watch)) {
                                return this.createError({
                                    message: `Hours/Week should not be greater than ${hrsPerWeekUpperLimit}`
                                });
                            }
                            const startDate = watch('startDate');
                            const endDate = watch('endDate');
                            const { dailyLimit, effectiveDays, proratedUpperLimit } = getProratedWeeklyHoursLimit(hrsPerWeekUpperLimit, startDate, endDate);
                            const newVal = Number(val);
                            if (newVal > proratedUpperLimit) {
                                return this.createError({
                                    message: `Hours per week must be between 1 to ${proratedUpperLimit} and hours per day must be between 1-${dailyLimit} (based on ${effectiveDays} working day${effectiveDays > 1 ? 's' : ''} between the selected dates)`
                                });
                            }
                            return true;
                        }
                    )
                    .typeError('Only numeric value is allowed.')
            }),
        ),
        defaultValues: isAllocation ? {
            ...defaultValues,
            include: [
                { label: 'Saturday', value: (defaultValues?.includeSaturday || (defaultValues?.include && defaultValues?.include[0]?.value)) || false },
                { label: 'Sunday', value: (defaultValues?.includeSunday || (defaultValues?.include && defaultValues?.include[1]?.value)) || false }],
            adjustedUtilizations: defaultValues?.allocationAdjustedUtilizations,
            wbsL4Code: wbsDropdownData?.demandData?.swiftWbsCode?.billable_l4_wbs_code || wbsDropdownData?.projectDetails?.wbsL4Code,
            wbsEngagementCode: wbsDropdownData?.demandData?.sapProject?.engagementCode,
        } : {
            ...defaultValues,
            hoursPerWeek: isEdit ? defaultValues.hoursPerWeek : hrsPerWeekUpperLimit,
            adjustedUtilizations: defaultValues?.allocationAdjustedUtilizations
        }
    });
    useEffect(() => {
        if (!defaultValues?.hoursPerWeek) {
            setValue('hoursPerWeek', (getWorkingHoursPerWeek({ isArticleGrade, isSpecialProject })));
        }
    }, [isArticle, isSpecialProject]);

    useEffect(() => {
        if (isAudit && !watch('isContinuityResource')) {
            clearErrors('continuityReason');
        }
    }, [watch('isContinuityResource')]);

    useEffect(() => {
        trigger();
    }, [watch('hoursPerWeek'), watch('include'), watch('startDate'), watch('endDate'), hrsPerWeekUpperLimit]);

    const isShowRequired = !(title === 'Change schedule' && Object.keys(defaultValues).length > 0);

    const fields = [
        ...(isAllocation ? [
            ...((!linkedWbsL4Count && !wbsDropdownData?.demandData?.sapProject?.engagementCode)
                ? [{
                    id: 0.11,
                    type: 'select-searchable',
                    name: 'wbsL4Code',
                    label: 'WBS/Eng. Code',
                    placeholder: '',
                    isRequired: true,
                    size: 'l',
                    isDisabled: true,
                    className: 'col-span-3',
                    value: { label: 'No WBS codes available', value: null },
                    options: [{ label: 'No WBS codes available', value: null }],
                }]
                : []),
            ...(((wbsDropdownData?.demandData?.swiftWbsCode?.billable_l4_wbs_code || wbsDropdownData?.projectDetails?.wbsL4Code ) && linkedWbsL4Count !== 0)
            ? [{
                id: 0.11,
                type: 'text-input',
                name: 'wbsL4Code',
                label: 'WBS/Eng. Code',
                placeholder: '',
                isRequired: true,
                size: 'l',
                isDisabled: true,
                className: 'col-span-3'
            }]
            : []),
        ...(wbsDropdownData?.demandData?.sapProject?.engagementCode
            && !(wbsDropdownData?.demandData?.swiftWbsCode?.billable_l4_wbs_code || wbsDropdownData?.projectDetails?.wbsL4Code)
            ? [{
                id: 0.11,
                type: 'text-input',
                name: 'wbsEngagementCode',
                label: 'WBS/Eng. Code',
                placeholder: '',
                isRequired: true,
                size: 'l',
                isDisabled: true,
                className: 'col-span-3'
            }]
            : []),
        ...(showWbsL4CodeDropdown
            ? [{
                id: 0.11,
                type: 'async-select-paginate',
                name: 'wbsL4Code',
                label: 'WBS/Eng. Code',
                placeholder: 'Select WBS/Eng. Code',
                loadOptions: async (search, setOffset, setHasMore) => await loadWbsL4CodeOptions({search, setOffset, setHasMore, projectId: wbsDropdownData?.projectDetails?.id, opportunityId: wbsDropdownData?.projectDetails?.opportunityId}),
                isRequired: true,
                size: '1',
                className: 'col-span-3',
                onChange: (data) => {
                    setValue('wbsL4Code', data?.label ? { label: data?.label ?? null, value: data?.value ?? null, ...data } : null, {shouldValidate: true, shouldDirty: true})
                },
            }]
            : [])] : []),
        {
            id: 1,
            type: 'calendor',
            name: 'startDate',
            label: 'Schedule Start Date',
            returnFormattedDate: true,
            isRequired: isShowRequired,
            size: 'l'
        },
        {
            id: 2,
            type: 'calendor',
            name: 'endDate',
            label: 'Schedule End date',
            returnFormattedDate: true,
            isRequired: isShowRequired,
            size: 'l',
            isDisabled: watch('startDate') === undefined,
            disabledDates: {
                before: watch('startDate')
            }
        },
        {
            id: 3,
            type: 'text-input',
            name: 'hoursPerWeek',
            label: 'Hours/week',
            placeholder: 'Enter Hours',
            isRequired: isShowRequired
        },
    ];

    if (isAllocation) {
        fields.push(
            {
                id: 4,
                type: 'checkbox-group',
                groupTitle: 'Include',
                name: 'include',
                direction: 'row',
                checkboxItems: [
                    {
                        value: watch('include') ? watch('include')[0].value : false,
                        label: 'Saturday'
                    },
                    {
                        value: watch('include') ? watch('include')[1].value : false,
                        label: 'Sunday'
                    }
                ]
            },
            {
                id: 5,
                type: 'check-box',
                label: 'Adjusted Utilizations',
                ariaLabel: 'Adjusted Utilizations',
                name: 'adjustedUtilizations',
                value: watch('adjustedUtilizations'),
                isRequired: false,
                showLabel: true,
                isDisabled: false,
                className: 'w-fit'
            }
        )
    };
    const buttons = [
        {
            label: 'Close',
            kind: Kind.secondaryLoud,
            color: Color.green,
            isDisabled: false,
            onClick: (e) => {
                reset()
                onClose(e)
            } 
        },
        {
            label: saveLabel,
            kind: Kind.primaryLoud,
            color: Color.green,
            isDisabled: !!Object.keys(errors).length,
            onClick: () => {
                // const { hoursPerWeek } = watch();
                // if (isAllocation && hoursPerWeek > hrsPerWeekUpperLimit && hoursPerWeek <= maxHoursPerWeek && !isArticleGrade) {
                //     setAlertAllocationHourShow({ show: true, message: `Hours per week is more than ${hrsPerWeekUpperLimit}, do you still wish to proceed?` });
                // } else {
                handleSubmit((data) => {
                    if (isProposal && demandData?.project?.isSpecialProject && !(validateMandatoryShiftTimings({
                        startDate: data?.startDate,
                        endDate: data?.endDate,
                        shiftTimings: data?.proposalShiftTimings
                    }))) {
                        setToastData({
                            show: true,
                            type: 'error',
                            message: "Shift is mandatory for Propel allocation."
                        });
                        return;
                    }                    
                    onSave({ ...data, isSpecialProject: isSpecialProject ?? false });
                })();
                // }
            }
        }
    ];
    const pathname = usePathname();
    const isAddProjectPage = pathname.includes('/projects/add');

    useEffect(() => {
        if (!show) return;
        if (watch('allocationShiftTimings') && Object.keys(watch('allocationShiftTimings')).length > 0) {
            return;
        }
        if (watch('proposalShiftTimings') && Object.keys(watch('proposalShiftTimings')).length > 0) {
            return;
        }
        if (defaultValues.hasAllocationShiftTimings) {
            fetchAllocationShiftTimings();
        } else if(defaultValues?.hasProposalShiftTimings) {
            fetchProposalShiftTimings();
        } else if (demandData?.hasDemandShiftTimings && demandData?.id) {
            fetchDemandShiftTimings();
        }
    }, [show]);

    const openShiftModal = (type) => {
        type === 'ocs' ? setShowOcsShiftModal(true) : setShowShiftModal(true);
        if (watch('allocationShiftTimings') && Object.keys(watch('allocationShiftTimings')).length > 0) {
            return;
        }
        if (watch('proposalShiftTimings') && Object.keys(watch('proposalShiftTimings')).length > 0) {
            return;
        }
        if (defaultValues.hasAllocationShiftTimings) {
            fetchAllocationShiftTimings();
        } else if(defaultValues?.hasProposalShiftTimings) {
            fetchProposalShiftTimings();
        } else if (demandData?.hasDemandShiftTimings && demandData?.id) {
            fetchDemandShiftTimings();
        }
    }

    const getAllocationShiftFromDemand = (demandShiftTimings) => {
        const startDate = dayjs(watch('startDate'));
        const endDate = dayjs(watch('endDate'));
        const filteredDemandShiftTimingFormData = {};
        for (const [date, value] of Object.entries(demandShiftTimings)) {
            const timingDate = dayjs(date);
            if (timingDate.isSameOrAfter(startDate, 'day') && timingDate.isSameOrBefore(endDate, 'day')) {
                filteredDemandShiftTimingFormData[date] = value;
            }
        }
        return filteredDemandShiftTimingFormData;
    }

    const fetchDemandShiftTimings = async () => {
        const response = await getDemandShiftTimingsByDemandId({ demandId: demandData?.id });
        if (response?.status && response?.entity) {
            const demandShiftTimingFormData = getDemandShiftTimingFormData(response?.entity);
            setValue('demandShiftTimings', getAllocationShiftFromDemand(demandShiftTimingFormData));
            setValue('allocationShiftTimings', getAllocationShiftFromDemand(demandShiftTimingFormData));
            if (isProposal) setValue('proposalShiftTimings', getAllocationShiftFromDemand(demandShiftTimingFormData));
        }
    }
    const fetchAllocationShiftTimings = async () => {
        const allocationDetails = defaultValues;
        const response = await getAllocationShiftTimingsByAllocationId({ allocationId: allocationDetails?.id });
        if (response?.status && response?.entity) {
            const allocationShiftTimingFormData = getDemandShiftTimingFormData(response?.entity);
            setValue('allocationShiftTimings', allocationShiftTimingFormData);
        }
    }

    const fetchProposalShiftTimings = async () => {
        const response = await getProposalShiftTimingsByProposalId({ proposalId: defaultValues?.proposalId });
        if (response?.status && response?.entity) {
            const allocationShiftTimingFormData = getDemandShiftTimingFormData(response?.entity);
            setValue('proposalShiftTimings', allocationShiftTimingFormData);
        }
    }

    const shiftTimings = useCallback(() => {
        const { allocationShiftTimings, proposalShiftTimings } = watch();
        if (proposalShiftTimings && Object.keys(proposalShiftTimings).length > 0 && isProposal) {
            return proposalShiftTimings;
        } else if (allocationShiftTimings && Object.keys(allocationShiftTimings).length > 0) {
            return allocationShiftTimings;
        } else if (demandData?.hasDemandShiftTimings && demandData?.id) {
            return watch('demandShiftTimings');
        } else if (demandData?.demandShiftTimings) {
            return getAllocationShiftFromDemand(demandData?.demandShiftTimings);
        }
        return {};
    }, [watch('resources[0].allocationShiftTimings'), demandData?.hasDemandShiftTimings, demandData?.id, watch('demandShiftTimings'), watch('proposalShiftTimings')]);
    const handleCreateAllocationShift = ({ data, shiftData, startDate, endDate }) => {
        const shiftTimings = generateShiftTimings({ shiftData, startDate, endDate });
        setValue('allocationShiftTimings', shiftTimings);
        if (isProposal) setValue('proposalShiftTimings', shiftTimings);
        setShowShiftModal(false);
        setShowOcsShiftModal(false);
    }

    return (
        <>
            <Drawer
                title={title}
                show={true}
                onClose={(e) => {
                    reset()
                    onClose(e)
                }}
                size='md'
                isFooter
                footer={<ButtonGroup buttons={buttons} />}
            >
                {isProposal && (
                    <div className='md:mt-4'>
                        <div className="border border-solid border-neutral-50 p-4 my-2">
                            <div className="flex gap-1 items-center">
                                <Text variant="bodySemibold" color="text-black" className='mr-4'>
                                    {isEdit ? 'Proposed Date' : 'Proposal Creation Date'}: {proposedDate}
                                </Text>
                                {
                                    isEdit ? <Text
                                        variant="bodySemibold" color="text-black"
                                    >
                                        Ageing: {proposalAgeing}
                                    </Text> : null
                                }
                            </div>
                        </div>
                    </div>
                )}
                <RenderFields
                    fields={fields}
                    control={control}
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                />
                <div className='flex flex-col gap-4 my-4'>
                    {
                        isAudit && (
                            <Checkbox
                                label='Continuity resource'
                                showLabel
                                value={watch('isContinuityResource') || false}
                                name='isContinuityResource'
                                onChangeHandler={(data) => {
                                    setValue('isContinuityResource', data.value);
                                    if (!data.value) {
                                        setValue('continuityReason', null);
                                        setValue('continuityReasonComment', null);
                                    }
                                }}
                                className='w-fit'
                            />
                        )
                    }
                    {
                        watch('isContinuityResource') && (
                            <SearchableSelect
                                name='continuityReason'
                                control={control}
                                register={register}
                                placeholder='Select reason'
                                options={continuityReasonsOption}
                                isError={'continuityReason' in errors}
                                errorMessage={errors['continuityReason']?.message}
                                label='Reason'
                                isRequired
                                onChange={(e) => {
                                    setValue('continuityReason', e, { shouldDirty: true, shouldValidate: true });
                                }}
                            />
                        )
                    }
                    {
                        (watch('isContinuityResource') && watch('continuityReason') && watch('continuityReason')?.value === 'Others') && (
                            <Input
                                type='text'
                                value={watch('continuityReasonComment')}
                                size='l'
                                label='Other Reason'
                                placeholder='Reason'
                                valueChanged={(val) => {
                                    setValue('continuityReasonComment', val);
                                }}
                            />
                        )
                    }
                </div>
                {demandData?.project?.isSpecialProject ?
                    <div className='flex gap-4 my-4'>
                        <Button label="Add / Edit shift" onClick={openShiftModal} />
                        <Button
                            label="Add / Edit OCS shift"
                            isDisabled={Object.keys(shiftTimings() ?? {}).length === 0}
                            onClick={() => openShiftModal('ocs')}
                        />
                    </div> : <></>}
            </Drawer>
            <AddShiftDrawer
                startDateLabel={`${isProposal ? 'Proposal ' : 'Allocation'} Start Date`}
                endDateLabel={`${isProposal ? 'Proposal ' : 'Allocation'} End Date`}
                shiftTimings={shiftTimings()}
                showAddShiftDrawer={showShiftModal}
                startDate={watch('startDate')}
                endDate={watch('endDate')}
                onHideAddShiftDrawer={() => { setShowShiftModal(false) }}
                onSubmit={handleCreateAllocationShift}
            />
            <AddShiftDrawerOCS
                startDateLabel='Allocation Start Date'
                endDateLabel='Allocation End Date'
                shiftTimings={shiftTimings()}
                showAddShiftDrawer={showOcsShiftModal}
                startDate={watch('startDate')}
                endDate={watch('endDate')}
                onHideAddShiftDrawer={() => { setShowOcsShiftModal(false) }}
                onSubmit={handleCreateAllocationShift}
            />
            {alertAllocationHourShow.show && <AlertModal
                show={alertAllocationHourShow.show}
                title={'Alert'}
                description={<Text>{alertAllocationHourShow.message}</Text>}
                cancelLabel="No"
                saveLabel="Yes"
                onClose={() => setAlertAllocationHourShow({ show: false })}
                onCancel={() => setAlertAllocationHourShow({ show: false })}
                onSave={async () => {
                    handleSubmit(onSave)();
                    setAlertAllocationHourShow({ show: false });
                }}
            />}
        </>
    );
}

export default Schedule;
